import React from "react";
import Svg, { Path } from "react-native-svg";

const AppIcon = () => {
  return (
    <Svg
      width="102"
      height="16"
      viewBox="0 0 102 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <Path
        d="M8.1298 15.9953C7.06673 16.0077 6.01173 15.8104 5.02595 15.4147C4.04017 15.019 3.1432 14.4327 2.38702 13.6899C1.63083 12.9472 1.03048 12.0626 0.620731 11.0876C0.210986 10.1125 0 9.06632 0 8.00963C0 6.95293 0.210986 5.90674 0.620731 4.93168C1.03048 3.95662 1.63083 3.07208 2.38702 2.3293C3.1432 1.58653 4.04017 1.0003 5.02595 0.60458C6.01173 0.20886 7.06673 0.0115197 8.1298 0.023994V4.11308C7.09036 4.11308 6.09349 4.52349 5.3585 5.25403C4.6235 5.98456 4.21059 6.97538 4.21059 8.00851C4.21059 9.04165 4.6235 10.0325 5.3585 10.763C6.09349 11.4935 7.09036 11.9039 8.1298 11.9039V15.9953Z"
        fill="#E40046"
      />
      <Path
        d="M63.8986 5.73276V15.9944H59.2028V5.78451H59.195C59.1979 5.50615 59.0894 5.23806 58.8934 5.03919C58.6975 4.84033 58.43 4.727 58.15 4.72412C57.8699 4.72124 57.6002 4.82906 57.4001 5.02385C57.2 5.21864 57.086 5.48445 57.0831 5.76281V5.78451H57.0753V15.9944H52.3789V5.74778C52.3789 5.73554 52.3789 5.72385 52.3789 5.71161V5.74778H52.3711C52.3711 5.46943 52.2598 5.20247 52.0618 5.00564C51.8638 4.80882 51.5952 4.69824 51.3151 4.69824C51.0351 4.69824 50.7665 4.80882 50.5685 5.00564C50.3704 5.20247 50.2592 5.46943 50.2592 5.74778H50.2513V15.9944H45.5578V5.71439C45.5598 4.65413 45.858 3.61525 46.4191 2.71353C46.9803 1.81182 47.7823 1.08269 48.7359 0.607419C49.6895 0.132147 50.7571 -0.0706009 51.8198 0.0217719C52.8824 0.114145 53.8984 0.498009 54.7545 1.13058C55.6106 0.512952 56.6213 0.14157 57.6757 0.0571658C58.7302 -0.0272382 59.7876 0.178596 60.7321 0.652095C61.6767 1.12559 62.4717 1.84847 63.0302 2.74144C63.5886 3.63442 63.8889 4.663 63.898 5.71439C63.8986 5.71884 63.8986 5.72552 63.8986 5.73276Z"
        fill="#E40046"
      />
      <Path
        d="M89.9944 11.3274V15.9947H81.1891V0.0234375H85.8854V11.3274H89.9944Z"
        fill="#E40046"
      />
      <Path
        d="M28.1967 0.0322266V4.70007H25.745V15.9957H21.0492V4.70007H18.5633V0.0322266H28.1967Z"
        fill="#E40046"
      />
      <Path
        d="M25.7449 0.0234375H21.0491V0.0312285H25.7449V0.0234375Z"
        fill="#E40046"
      />
      <Path
        d="M42.6318 0.375977V5.48177C42.6202 6.58475 42.2883 7.66091 41.6759 8.58082C41.0636 9.50074 40.1969 10.2252 39.1801 10.6671V15.9961H34.4843V10.6304C33.4882 10.1794 32.6419 9.45555 32.0448 8.54369C31.4477 7.63183 31.1243 6.56972 31.1127 5.48177V0.375977H35.8084V5.44505H35.8157V5.4673C35.8143 5.60693 35.841 5.74543 35.8942 5.87468C35.9473 6.00394 36.0259 6.12135 36.1252 6.22005C36.2246 6.31875 36.3428 6.39674 36.4729 6.44947C36.603 6.50219 36.7423 6.52859 36.8828 6.52711C37.0233 6.52562 37.1621 6.4963 37.291 6.44084C37.4199 6.38538 37.5364 6.30492 37.6337 6.20415C37.7309 6.10338 37.807 5.98433 37.8573 5.85398C37.9077 5.72364 37.9314 5.58461 37.9271 5.44505H37.936V0.375977H42.6318Z"
        fill="#E40046"
      />
      <Path
        d="M15.6823 0.0234375H10.9865V15.9947H15.6823V0.0234375Z"
        fill="#E40046"
      />
      <Path
        d="M101.715 11.3274V15.9947H92.9092V0.0234375H97.6055V11.3274H101.715Z"
        fill="#E40046"
      />
      <Path
        d="M78.2653 5.71407C78.2503 4.20566 77.6369 2.76408 76.5585 1.70269C75.48 0.641304 74.0237 0.0458984 72.506 0.0458984C70.9883 0.0458984 69.5319 0.641304 68.4535 1.70269C67.375 2.76408 66.7617 4.20566 66.7467 5.71407C66.7467 5.72965 66.7467 5.74468 66.7467 5.76026V15.9997H71.4425V12.6396H73.5701V15.9941H78.2658V5.73243C78.2658 5.7252 78.2658 5.71852 78.2653 5.71407ZM73.5701 7.97453H71.4425V5.78419H71.4509C71.4509 5.50583 71.5621 5.23888 71.7602 5.04205C71.9582 4.84522 72.2268 4.73465 72.5068 4.73465C72.7869 4.73465 73.0555 4.84522 73.2535 5.04205C73.4515 5.23888 73.5628 5.50583 73.5628 5.78419H73.5706L73.5701 7.97453Z"
        fill="#E40046"
      />
    </Svg>
  );
};

export default AppIcon;
